import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { JwtHelper } from 'angular2-jwt';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthenticationService {
  public token: string;
  tokenServiceUrl = '/api/user/login';
  refreshTokenServiceUrl = '/api/user/refreshtoken';
  headers: Headers = new Headers({'Content-Type': 'application/json' });

  constructor(private http: Http) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.token = currentUser && currentUser.token;
  }

  checkAndRefreshToken(): Observable<boolean> {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const jwtHelper = new JwtHelper();

    if (jwtHelper.isTokenExpired(currentUser.token)) {
      return this.http.post(this.tokenServiceUrl, '"' + currentUser.refresh_token + '"', { headers: this.headers})
       .map((response: Response) => {
        const token = response.json() && response.json().access_token;
        const refreshToken = response.json() && response.json().refresh_token;
        if (token) {
          this.token = token;
          localStorage.setItem('currentUser', JSON.stringify({
            username: currentUser.username,
            token: token,
            refresh_token: refreshToken }));
          return true;
        } else {
          return false;
        }
      });
    }
    return Observable.apply(true);
    // return Observable.create((observer: Observer<boolean>) => {
    //   observer.next(true);
    //   observer.complete();
    // });
  }

  login(username: string, password: string, accountType: string): Observable<boolean> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(this.tokenServiceUrl, JSON.stringify({ username: username, password: password, endpointName: accountType}), { headers: this.headers })
      .map((response: Response) => {
        const token = response.json() && response.json().access_token;
        const refreshToken = response.json() && response.json().refresh_token;
        if (token) {
          this.token = token;
          localStorage.setItem('currentUser', JSON.stringify({ username: username, token: token, refresh_token: refreshToken }));
          return true;
        } else {
          return false;
        }
      })
      .catch((error: any) => {
        console.error(error);
        return error;
      });
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem('currentUser');
  }

  userLoggedIn(): boolean {
    return this.token !== null;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts